import React from 'react';
import PropTypes from 'prop-types';

class Land extends React.Component {
  constructor (props) {
    super(props);

    this.limitPropertyOutput = 4;
    this.item = this.props.item;
    this.property = this.item.getProperty();
    this.room = this.property.getRoom();
    this.building = this.property.getBuilding();

    this.land = this.property.getLandPlot();
    this.usageCategory = this.land.getUsageCategory();
    this.landArea = this.land.getTotalArea();

    this.totalArea = this.room.getTotalArea();
    this.totalFloors = this.building.getFloorsNumberAboveGround();
    this.material = this.building.getMaterial();
    this.houseInfo = [
      this.totalArea                   && (<div className='main-param' key={1}>{ 'Пл.дома: ' + this.totalArea.getLabel(false) }</div>),
      this.totalFloors                 && (<div className='param' key={2}>{ 'этажей: ' + this.totalFloors }</div>),
      this.material                    && (<div className='param' key={3}>{ 'материал: ' + this.material.get('middleName') }</div>),
      this.building.hasCellar()        && (<div className='param' key={4}>{ this.building.getLabelCellar() }</div>),
      this.building.hasElectricity()   && (<div className='param' key={5}>{ this.building.getLabelElectricity() }</div>),
      this.building.hasHeating()       && (<div className='param' key={6}>{ this.building.getLabelHeating() }</div>),
      this.building.hasWater()         && (<div className='param' key={7}>{ this.building.getLabelWater() }</div>),
      this.building.hasCanalization()  && (<div className='param' key={8}>{ this.building.getLabelCanalization() }</div>)
    ].filter(Boolean).slice(0, this.limitPropertyOutput + 1);

    this.plotInfo = [
      this.landArea      && (<div className='main-param' key={1}>{ 'Пл.участка: ' + this.landArea.getLabel(false) }</div>),
      this.usageCategory && (<div className='param' key={2}>{ this.usageCategory.get('middleName') }</div>)
    ].filter(Boolean);
  }



  render () {
    return (
      <div className='property__land'>
        <div className='land__col'>
          { this.houseInfo }
        </div>
        <div className='land__col'>
          { this.plotInfo }
        </div>
      </div>
    );
  }
}

Land.propTypes = {
  item: PropTypes.object.isRequired
};

Land.defaultProps = {};

export default Land;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/FlexItems/Items/Land.jsx